export default "__VITE_ASSET__Bohl2N_2__"